module.exports = __webpack_public_path__ + "img/2.a29627a4.jpg";